<template>
  <ArlaNavbar />

  <section class="hero">
    <div class="hero-body">
      <div class="container">
        <div class="columns is-multiline">
          <div class="column is-12">
            <p class="has-text-centered arlainterface-regular font-18">
              Kiva!<br />
              Seuraavaksi valitse minkäväriset Poksis-mehukuplat haluat videoosi leijailemaan, ja onko niitä vähän vai paljon. Se poksahtaa!
            </p>
          </div>
        </div>
        <div class="columns is-multiline">
          <div class="column is-6">
            <p class="has-text-centered font-18 mb-3"><b>Persikka</b></p>
            <figure
              class="image bubble-image"
              :class="{ 'bubble-selected': bubbleSelected == 1 }"
              @click="selectBubble(1)"
            >
              <img src="../assets/img/bubble_yellow_1.png" />
            </figure>
          </div>
          <div class="column is-6">
            <p class="has-text-centered font-18 mb-3"><b>Mansikka</b></p>
            <figure
              class="image bubble-image"
              :class="{ 'bubble-selected': bubbleSelected == 2 }"
              @click="selectBubble(2)"
            >
              <img src="../assets/img/bubble_red_2.png" />
            </figure>
          </div>
          <div class="column is-6">
            <p class="has-text-centered font-18 mb-3"><b>Mustikka</b></p>
            <figure
              class="image bubble-image"
              :class="{ 'bubble-selected': bubbleSelected == 3 }"
              @click="selectBubble(3)"
            >
              <img src="../assets/img/bubble_blue_3.png" />
            </figure>
          </div>
        </div>
        <div class="columns is-mobile">
          <div class="column is-flex is-justify-content-center is-align-items-center">
            <span class="font-18">Vähän kuplia</span>
            <label class="switch mx-2">
              <input type="checkbox" v-model="bubbleAmount"/>
              <span class="slider round"></span>
            </label>
            <span class="font-18">Paljon kuplia</span>
          </div>
        </div>
        <div class="columns">
          <div class="column has-text-centered">
            <button
              class="button arla-button dark-red-btn"
              @click="goToAnimationSelector"
            >
              Eteenpäin!
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>

  <ArlaFooter />
</template>

<script>
import ArlaNavbar from "../components/ArlaNavbar";
import ArlaFooter from "../components/ArlaFooter";
import {mapMutations, mapGetters, mapActions } from "vuex"

export default {
  name: "VideoBubbleSelector",
  components: {
    ArlaNavbar,
    ArlaFooter,
  },
  data() {
    return {
      bubbleAmount: false, // 'LOW' or 'HIGH'
      bubbleSelected: 1,
    };
  },
  methods: {
    ...mapMutations({
      setVideoData: 'setVideoData'
    }),
    ...mapGetters({
      getVideoData: 'getVideoData',
    }),
		...mapActions({
      patchVideo: 'patchVideo',
    }),  
    selectBubble(bubbleId) {
      this.bubbleSelected = bubbleId;
    },
    goToAnimationSelector() {
      if (this.bubbleSelected) {
        let quantity = this.bubbleAmount ? 'HIGH' : 'LOW';
        this.setVideoData({...this.getVideoData(), bubble_quantity:quantity, bubble_selected:this.bubbleSelected})
        this.$router.push({
          path: `/${this.$route.params.birdUuid}/${this.$route.params.videoUuid}/video/animation`,
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
@use "../assets/sass/mybulma" as *;
.bubble-image {
  cursor: pointer;
  transition: transform 0.3s;
}
.bubble-image:hover {
  transform: scale(1.05);
}
.bubble-selected {
  border: 3pt solid $dark-red;
}

/* Start Togghe switch */
.switch {
  position: relative;
  display: inline-block;
  width: 160px;
  height: 34px;
}

/* Hide default HTML checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #2196f3;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196f3;
}

input:checked + .slider:before {
  -webkit-transform: translateX(126px);
  -ms-transform: translateX(126px);
  transform: translateX(126px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
  background-color: $dark-red;
}
/* End Togghe switch */
</style>
